
import React from "react";
import * as Material from "@mui/material";

export default function MetricCard({ title, metric, submetric, loading: metricLoading }) {
    return (
        <div className="metric-item">
            <span style={{ opacity: 0.65 }}>{title}</span>
            <div className="metric-content">
                {metricLoading ? (
                    <Material.Skeleton
                        variant="text"
                        width={60}
                        height={24}
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            '&::after': {
                                background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)'
                            }
                        }}
                    />
                ) : (
                    <h3 className="bold">{metric}</h3>
                )}
                {metricLoading ? (
                    <Material.Skeleton
                        variant="text"
                        width={80}
                        height={16}
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            '&::after': {
                                background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)'
                            }
                        }}
                    />
                ) : (
                    <span style={{ opacity: 0.5 }}>{submetric}</span>
                )}
            </div>
        </div>
    )
}
